import React, { useContext, createContext } from 'react';
import PropTypes from 'prop-types';

var PagePropsContext = /*#__PURE__*/createContext(undefined);
var PagePropsProvider = function PagePropsProvider(_ref) {
  var children = _ref.children,
    pageProps = _ref.pageProps;
  return /*#__PURE__*/React.createElement(PagePropsContext.Provider, {
    value: pageProps
  }, children);
};
function usePageProps() {
  var context = useContext(PagePropsContext);
  if (context === undefined && process.env.NODE_ENV === 'development') {
    console.warn('usePageProps must be used within a PagePropsProvider');
  }
  return context;
}
PagePropsProvider.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.shape({}),
  pageProps: PropTypes.shape({})
} : {};

export { PagePropsProvider, usePageProps };
